import { SVGAttributes } from "react";

export const AtlassianGuardMarkBrand = (
    props: SVGAttributes<SVGSVGElement>
) => {
    return (
        <svg
            width="52"
            height="50"
            viewBox="0 0 52 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M2.06835 19.964H49.0108C50.3597 19.964 51.0791 19.2446 51.0791 17.8957V2.06835C51.0791 0.719424 50.3597 0 49.0108 0H39.1187C37.7698 0 37.0504 0.719424 37.0504 2.06835V10.0719H32.554V2.06835C32.554 0.719424 31.8345 0 30.4856 0H20.5935C19.2446 0 18.5252 0.719424 18.5252 2.06835V10.0719H14.0288V2.06835C14.0288 0.719424 13.3094 0 11.9604 0H2.06835C0.719424 0 0 0.719424 0 2.06835V17.8957C0 19.2446 0.719424 19.964 2.06835 19.964ZM2.8777 33.813C1.88849 31.0252 1.25899 28.1475 1.07914 24.8201C0.989209 23.6511 1.52878 23.0216 2.78777 23.0216H48.2914C49.5504 23.0216 50.0899 23.5612 50.0899 24.6403C49.9101 27.9676 49.2806 31.0252 48.2014 33.813C47.6619 35.2518 46.8525 35.8813 45.3237 35.8813H5.7554C4.22662 35.8813 3.41727 35.2518 2.8777 33.813ZM44.5144 41.277C40.1978 46.5827 33.0935 50 25.5396 50C17.9856 50 10.7014 46.5827 6.47482 41.277C5.39568 39.8381 5.93525 38.9389 7.01439 38.9389H44.0647C45.1439 38.9389 45.6835 39.8381 44.5144 41.277Z"
                fill="#1868DB"
            />
        </svg>
    );
};
